import { render } from "./GatewaysList.vue?vue&type=template&id=2e10e56e&ts=true"
import script from "./GatewaysList.vue?vue&type=script&lang=ts"
export * from "./GatewaysList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__